import { svgIconClasses } from '@mui/material';
import { shadow1 } from '../shadows';
// TODO: to delete all unused comments later when dark scheme is fully applied
export const MuiButtonBase = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            borderWidth: 0,
            whiteSpace: 'nowrap',
            ':hover': {
                borderWidth: 0,
            },
        },
    },
};
export const MuiButton = {
    variants: [
        // Custom variants added:
        {
            props: { variant: 'soft' },
            style: ({ theme }) => ({
                color: theme.palette.primary.dark,
                boxShadow: ` 0 0 #0000,  0 0 #0000, ${shadow1}`,
            }),
        },
        {
            props: { size: 'extraSmall' },
            style: { fontSize: '13px', padding: '.125rem .5rem' },
        },
        // { props: { size: 'large' }, style: { '& .MuiButton-icon': { fontSize: '22px' } } },
    ],
    styleOverrides: {
        sizeMedium: {
            lineHeight: '1.5rem',
            padding: '6px 16px',
        },
        sizeSmall: {
            padding: '.3125rem .5rem',
        },
        root: ({ ownerState, theme }) => ({
            height: 'fit-content',
            width: 'fit-content',
            boxShadow: shadow1,
            '&:hover': {
                boxShadow: shadow1,
            },
            // TODO: Not working for some reason. Try in next versions of MUI
            // focusVisible: {
            // 	outlineColor: ownerState?.color ?? theme.palette.primary.dark,
            // 	outlineOffset: '2px',
            // 	outlineWidth: '2px',
            // 	outlineStyle: 'solid',
            // },
            // TODO: try case above ^^
            '&.Mui-focusVisible': {
                outlineColor: ownerState
                    ? ownerState.color === 'primary'
                        ? theme.palette.primary.dark
                        : ownerState.color === 'secondary'
                            ? theme.palette.secondary.dark
                            : ownerState.color === 'success'
                                ? theme.palette.success.dark
                                : ownerState.color === 'error'
                                    ? theme.palette.error.dark
                                    : ownerState.color === 'info'
                                        ? theme.palette.info.dark
                                        : ownerState.color === 'warning'
                                            ? theme.palette.warning.dark
                                            : theme.palette.primary.dark
                    : theme.palette.primary.dark,
                outlineOffset: '2px',
                outlineWidth: '2px',
                outlineStyle: 'solid',
            },
            // Bugfix: if we add extraSmall size for the button it won't work with variant 'text'
            // '&.MuiButton-textSizeExtraSmall': {
            // 	fontSize: '13px',
            // 	padding: '.125rem .5rem',
            // },
            variants: [
                {
                    props: { size: 'medium' },
                    style: {
                        '& .MuiButton-icon': {
                            [`.${svgIconClasses.root}`]: {
                                width: '1.125rem',
                                color: theme.palette.zinc[600],
                            },
                        },
                    },
                },
                {
                    props: { size: 'extraSmall' },
                    style: {
                        fontSize: theme.typography.caption.fontSize,
                        padding: theme.spacing(0.5, 2), //'.125rem .5rem',
                    },
                },
                // "text"
                {
                    props: { variant: 'text', color: 'primary' },
                    style: [
                        {
                            color: theme.palette.primary.dark,
                            backgroundColor: theme.palette.primary.backgroundLight,
                            ':hover': {
                                backgroundColor: theme.palette.primary.background,
                            },
                        },
                        theme.applyStyles('dark', {
                            color: theme.palette.primary.lighter,
                            backgroundColor: `color-mix(in oklab, ${theme.vars.palette.indigo[900]} 70%, transparent)`,
                            ':hover': {
                                backgroundColor: `color-mix(in oklab, ${theme.vars.palette.indigo[900]} 90%, transparent)`,
                            },
                        }),
                    ],
                },
                {
                    props: { variant: 'text', color: 'secondary' },
                    style: {
                        color: theme.palette.secondary.dark,
                        backgroundColor: theme.palette.secondary.backgroundLight,
                        ':hover': {
                            backgroundColor: theme.palette.secondary.background,
                        },
                    },
                },
                {
                    props: { variant: 'text', color: 'success' },
                    style: {
                        color: theme.palette.success.dark,
                        backgroundColor: theme.palette.success.backgroundLight,
                        ':hover': {
                            backgroundColor: theme.palette.success.background,
                        },
                    },
                },
                {
                    props: { variant: 'text', color: 'info' },
                    style: {
                        color: theme.palette.info.dark,
                        backgroundColor: theme.palette.info.backgroundLight,
                        ':hover': {
                            backgroundColor: theme.palette.info.background,
                        },
                    },
                },
                {
                    props: { variant: 'text', color: 'warning' },
                    style: {
                        color: theme.palette.warning.dark,
                        backgroundColor: theme.palette.warning.backgroundLight,
                        ':hover': {
                            backgroundColor: theme.palette.warning.background,
                        },
                    },
                },
                {
                    props: { variant: 'text', color: 'error' },
                    style: {
                        color: theme.palette.error.dark,
                        backgroundColor: theme.palette.error.backgroundLight,
                        ':hover': {
                            backgroundColor: theme.palette.error.background,
                        },
                    },
                },
                // "contained"
                {
                    props: { variant: 'contained', color: 'primary' },
                    style: getContainedButtonColorStyle(theme, 'primary'),
                },
                {
                    props: { variant: 'contained', color: 'secondary' },
                    style: getContainedButtonColorStyle(theme, 'secondary'),
                },
                {
                    props: { variant: 'contained', color: 'success' },
                    style: getContainedButtonColorStyle(theme, 'success'),
                },
                {
                    props: { variant: 'contained', color: 'warning' },
                    style: getContainedButtonColorStyle(theme, 'warning'),
                },
                {
                    props: { variant: 'contained', color: 'error' },
                    style: getContainedButtonColorStyle(theme, 'error'),
                },
            ],
        }),
        text: ({ theme }) => ({
            // boxShadow: ` 0 0 #0000,  0 0 #0000, ${shadowSm}`,
            // color: theme.palette.common.white,
            '&.Mui-disabled': {
                backgroundColor: theme.palette.background.default,
                opacity: 0.8,
            },
        }),
        // textPrimary: ({ ownerState, theme }) => [
        // 	{
        // 		color: theme.palette.primary.dark,
        // 		backgroundColor: theme.palette.primary.backgroundLight,
        // 		':hover': {
        // 			backgroundColor: theme.palette.primary.background,
        // 		},
        // 	},
        // 	theme.applyStyles('dark', {
        // 		// color: theme.palette.primary.light,
        // 		color: theme.palette.primary.lighter,
        // 		// backgroundColor: alpha(theme.palette.indigo[900], 0.7),
        // 		backgroundColor: `color-mix(in oklab, ${theme.vars.palette.indigo[900]} 70%, transparent)`,
        // 		':hover': {
        // 			// backgroundColor: alpha(theme.palette.indigo[900], 0.9),
        // 			backgroundColor: `color-mix(in oklab, ${theme.vars.palette.indigo[900]} 90%, transparent)`,
        // 		},
        // 	}),
        // ],
        // textSecondary: ({ ownerState, theme }) => ({
        // 	color: theme.palette.secondary.dark,
        // 	backgroundColor: theme.palette.secondary.backgroundLight,
        // 	':hover': {
        // 		backgroundColor: theme.palette.secondary.background,
        // 	},
        // }),
        // textSuccess: ({ ownerState, theme }) => ({
        // 	color: theme.palette.success.dark,
        // 	backgroundColor: theme.palette.success.backgroundLight,
        // 	':hover': {
        // 		backgroundColor: theme.palette.success.background,
        // 	},
        // }),
        // textInfo: ({ ownerState, theme }) => ({
        // 	color: theme.palette.info.dark,
        // 	backgroundColor: theme.palette.info.backgroundLight,
        // 	':hover': {
        // 		backgroundColor: theme.palette.info.background,
        // 	},
        // }),
        // textWarning: ({ ownerState, theme }) => ({
        // 	color: theme.palette.warning.dark,
        // 	backgroundColor: theme.palette.warning.backgroundLight,
        // 	':hover': {
        // 		backgroundColor: theme.palette.warning.background,
        // 	},
        // }),
        // textError: ({ ownerState, theme }) => ({
        // 	color: theme.palette.error.dark,
        // 	backgroundColor: theme.palette.error.backgroundLight,
        // 	':hover': {
        // 		backgroundColor: theme.palette.error.background,
        // 	},
        // }),
        contained: ({ theme }) => ({
            color: theme.palette.common.white,
        }),
        // containedPrimary: ({ ownerState, theme }) => ({
        // 	'&.Mui-disabled': {
        // 		backgroundColor: theme.palette.primary.main,
        // 		color: theme.palette.common.white,
        // 		opacity: '50%',
        // 	},
        // }),
        // containedSecondary: ({ ownerState, theme }) => ({
        // 	'&.Mui-disabled': {
        // 		backgroundColor: theme.palette.secondary.main,
        // 		color: theme.palette.common.white,
        // 		opacity: '50%',
        // 	},
        // }),
        // containedSuccess: ({ ownerState, theme }) => ({
        // 	'&.Mui-disabled': {
        // 		backgroundColor: theme.palette.success.main,
        // 		color: theme.palette.common.white,
        // 		opacity: '50%',
        // 	},
        // }),
        // containedWarning: ({ ownerState, theme }) => ({
        // 	'&.Mui-disabled': {
        // 		backgroundColor: theme.palette.warning.main,
        // 		color: theme.palette.common.white,
        // 		opacity: '50%',
        // 	},
        // }),
        // containedError: ({ ownerState, theme }) => ({
        // 	'&.Mui-disabled': {
        // 		backgroundColor: theme.palette.error.main,
        // 		color: theme.palette.common.white,
        // 		opacity: '50%',
        // 	},
        // }),
        outlined: ({ theme }) => [
            {
                // TODO: this should be deleted (after it's moved to `sizeMedium` block, since all the buttons should have
                // padding 5px 15px and border)
                padding: '5px 15px',
                color: theme.palette.text.primary,
                // backgroundColor: '#fff',
                backgroundColor: 'transparent',
                //fontWeight: theme.typography.fontWeightBold,
                // borderWidth: 0,
                borderWidth: 1,
                borderStyle: 'solid',
                // boxShadow: getButtonAndInputBoxShadow(theme),
                // TODO: check later, mb boxShadow here is already not necessary.
                boxShadow: 'none',
                // borderColor: alpha(theme.palette.text.primary, 0.1),
                borderColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 10%, transparent)`,
                ':hover': {
                    borderWidth: 1,
                    // backgroundColor: theme.palette.background.light,
                    backgroundColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 2.5%, transparent)`,
                    // boxShadow: getButtonAndInputBoxShadow(theme),
                    boxShadow: 'none',
                },
                '&.Mui-disabled': {
                    opacity: 0.5,
                },
            },
            theme.applyStyles('dark', {
                borderColor: `color-mix(in oklab, ${theme.vars.palette.common.white} 15%, transparent)`,
                ':hover': {
                    backgroundColor: `color-mix(in oklab, ${theme.vars.palette.common.white} 5%,transparent)`,
                },
            }),
        ],
        // TODO: to delete later after mui v9 fixes are found to be correct
        // TODO: check if it had been fixed.
        // `icon:` Not working for some reason. Duplicated in iconSize[SML]
        // icon: ({ ownerState, theme }) => ({
        // 	[`.${svgIconClasses.root}`]: {
        // 		color: theme.palette.zinc[700],
        // 	},
        // }),
        // iconSizeMedium: ({ ownerState, theme }) => ({
        // 	[`.${svgIconClasses.root}`]: {
        // 		width: '1.125rem',
        // 		color: theme.palette.zinc[600],
        // 	},
        // }),
    },
};
const getContainedButtonColorStyle = (theme, paletteColor) => {
    return {
        '&.Mui-disabled': {
            backgroundColor: theme.palette[paletteColor].main,
            color: theme.palette.common.white,
            opacity: '50%',
        },
    };
};
